import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { ILaboratoryProjects } from "./routeType";

import type { IPickMutation } from "@/api";
import { getApi } from "@api/apiPath";
import { axiosClient, queryClient } from "@api/clients.ts";
import { useGetAllMemberLaboratoryProjects } from "@/api/members/laboratories/projects/getAll";
import { useGetMemberLaboratoryProject } from "@/api/members/laboratories/projects/get";

const { getPath } = getApi("members.laboratories.projects.put");

type IExtractedRouteType = ILaboratoryProjects["laboratoryProjectSingleUpdate"];

export type IPutMemberLaboratoryProject = IPickMutation<IExtractedRouteType>;

const putMemberLaboratoryProject: MutationFunction<
  IPutMemberLaboratoryProject["response"],
  IPutMemberLaboratoryProject["variables"]
> = ({ labId, projectId, ...data }) => {
  return axiosClient.put(getPath({ labId, projectId }), data);
};

export const usePutMemberLaboratoryProject = createMutation({
  mutationFn: putMemberLaboratoryProject,
  onSuccess: (_, { labId }) => {
    queryClient.invalidateQueries({
      queryKey: useGetAllMemberLaboratoryProjects.getKey(),
    });
    queryClient.invalidateQueries({
      queryKey: useGetMemberLaboratoryProject.getKey({ labId }),
    });
  },
});
